import React  from "react";
import { connect } from "react-redux";
import SummaryCard from "components/widget/SummaryCard";
import TrainingOverviewTab from "./components/TrainingOverviewTab";
import Card from "components/card";
import { LucideAward, LucideBookOpen, LucideClock, LucideLineChart } from "lucide-react";



const TrainingOverviews = () => {
	return (

    <div>
	    <div>
        
        <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 3xl:grid-cols-4">
          <SummaryCard
            title={"Total Enrollments"}
            icon={<LucideBookOpen size={16}/>}
            displayCount={22}
            description={"Across all courses"}
            textColor="text-black-600"

          />	

          <SummaryCard
            title={"Completed"}
            icon={<LucideAward size={16}/>}
            displayCount={72}
            description={"Certificates issued"}
            textColor="text-green-600"
          />

          <SummaryCard
            title={"In Progress"}
            icon={<LucideClock size={16}/>}
            displayCount={82}
            description={"Active learners"}
            textColor="text-blue-600"
          />		
          <SummaryCard
            title={"Avg. Completion"}
            icon={<LucideLineChart size={16}/>}
            displayCount={"92%"}
            description={"Completion rate"}
            textColor="text-black-600"
          />	
          
        </div>
      </div>
      <div className="w-full mt-5">
          <TrainingOverviewTab />
      </div>
    </div>
	

      
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingOverviews);